import { AuthProvider } from '@/context/AuthContext.tsx';
import { TenantProvider } from '@/context/TenantContext.tsx';
import { AppRouter } from '@/routes/AppRouter.tsx';

/**
 * App — root component.
 *
 * Provider order matters:
 *  1. TenantProvider  — resolves tenant from subdomain / localStorage
 *  2. AuthProvider    — authentication state (depends on tenant)
 *  3. AppRouter       — renders routes (depends on auth state)
 */
export default function App() {
  return (
    <TenantProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </TenantProvider>
  );
}
